import getSelectors from '../../shared/store/selectorsFactory';
import { adminPageNames } from '../../shared/adminPageNames';

export const sharedSelectors = getSelectors(adminPageNames.BOOK_TO_TAX_CODE_DESCRIPTIONS);
